import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import Cash from '../../../../assets/images/cash.svg';
import Safari from '../../../../assets/images/safari.svg';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionThreeProps {
  section: OnboardingSummary;
}

const SectionThree = ({ section }: SectionThreeProps) => {
  const { idealCustomerProfile, buyingSignals } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>
        Generating qualified sales leads for my business
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Safari} alt='Safari' />{' '}
            Ideal customer profile (ICP):
          </div>
          <div className='text-lg'>{idealCustomerProfile}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Cash} alt='Cash' />{' '}
            What signals indicate a prospect has budget, authority, and an
            immediate need?
          </div>
          <div className='text-lg'>{buyingSignals}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionThree;
